import React from 'react'
import { InteractionContext } from '@context/interaction-context/interactionContext'
import { WidgetHOC, WidgetProps } from './WidgetHOC'

const InsuranceToggleContainer = React.lazy(() =>
  import('@features/insurance-toggle/InsuranceToggle').then(m => ({ default: m.InsuranceToggle }))
)

export const ToggleWidget: React.FC<WidgetProps> = props => {
  const { widgetContext } = props

  return (
    <WidgetHOC widgetContext={widgetContext}>
      <InteractionContext.Provider value={{ name: 'insurance-toggle', type: 'action' }}>
        <InsuranceToggleContainer />
      </InteractionContext.Provider>
    </WidgetHOC>
  )
}
